import routes from '../../../router.js';
import testUser from './testUser.js';

function loadUser() {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV == 'dev') {
      setTimeout(function() {
        resolve(testUser.data);
      }, 500);
    } else {
      const headers = {
        headers: {
          Accept: 'application/json',
        },
        method: 'GET',
      };

      fetch(routes.buy.user, headers)
        .then(response => response.json())
        .then(json => {
          if (json.status === 'success') {
            resolve(json.data);
          } else {
            reject(new Error(`Ошибка загрузки пользователя: ${json.errors}`));
          }
        })
        .catch(() => {
          reject(new Error(`Ошибка загрузки пользователя`));
        });
    }
  });
}

export default loadUser;
